// extracted by mini-css-extract-plugin
module.exports = {"Head":"Portfolio__Head_3YXE9 grid grid--col-12","Title":"Portfolio__Title_1f2jS","Icons":"Portfolio__Icons_2RDPm d-none d-md-block","List":"Portfolio__List_2PVYY grid"};